<script>
import tag from '@/js/util/props/tag'
import eventBus from '@/js/util/EventBus'

export default {
  props: {
    ...tag,

    disclosureId: {
      type: String,
      required: true,
    },
    transitionName: {
      type: String,
      default: null,
    },
    mode: {
      type: String,
      default: 'show',
      validate: value => [
        'if',
        'show',
      ].includes(value),
    },
  },
  data() {
    return {
      expanded: undefined,
    }
  },
  created() {
    eventBus.$on('toggle', this.toggle)
    eventBus.$emit('created:container', this.disclosureId)
  },
  methods: {
    toggle({ controls, expanded }) {
      if (controls === this.disclosureId) {
        this.expanded = expanded
      }
    },
    createChild(createElement, data) {
      if (!(this.mode === 'show' || this.expanded)) {
        return undefined
      }
      // no animation
      if (!this.transitionName) {
        return createElement(this.tag, data, this.$slots.default)
      }
      return createElement(this.transitionName, [
        createElement(this.tag, data, this.$slots.default),
      ])
    },
  },
  render(createElement) {
    const data = {
      attrs: {
        id: this.disclosureId,
      },
    }
    if (this.mode === 'show') {
      data.directives = [{
        name: 'show',
        value: this.expanded,
      }]
    }
    return this.createChild(createElement, data)
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/disclosure/DisclosureContent.vue